import { FormFieldsContainer } from '../Shared/styles'
import Info from 'components/inputs/Material/Info/index'
import FooterButtons from 'components/inputs/Material/FooterButtons/index'
import MessageForUser from 'components/inputs/Material/MessageForUser'
import SendDocumentFields from 'components/inputs/SendDocumentFields'

export default function SendDocument() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
        <MessageForUser hideUrl />
        <SendDocumentFields />
      </FormFieldsContainer>
      <FooterButtons showLogicButton={false} />
    </>
  )
}
